import { canAccess, hasPermission } from '../../rbac';

export const REGISTRY_QUEUE_DOMAINS = Object.freeze([
  Object.freeze({ resourceType: 'business', permissionModule: 'businesses' }),
  Object.freeze({ resourceType: 'property', permissionModule: 'properties' }),
]);

export const canViewRegistryQueueDomain = (user, permissionModule) => (
  canAccess(user?.role, permissionModule, user)
);

export const canVerifyRegistryQueueDomain = (user, permissionModule) => (
  hasPermission(user, permissionModule, 'verify')
);

export const canOpenRegistryReviewQueue = user => REGISTRY_QUEUE_DOMAINS.some(domain => (
  canViewRegistryQueueDomain(user, domain.permissionModule)
  || canVerifyRegistryQueueDomain(user, domain.permissionModule)
));

export const normalizeRegistryQueuePage = (payload = {}, defaults = {}) => {
  const page = Math.max(1, Number(payload.page) || Number(defaults.page) || 1);
  const limit = Math.min(100, Math.max(1, Number(payload.limit) || Number(defaults.limit) || 20));
  const total = Math.max(0, Number(payload.total) || 0);
  const totalPages = Math.max(1, Number(payload.total_pages) || Math.ceil(total / limit) || 1);
  return {
    rows: Array.isArray(payload.change_requests) ? payload.change_requests : [],
    page,
    limit,
    total,
    totalPages,
  };
};

export const buildRegistryReviewPath = ({ tenantSlug, resourceType, resourceUid }) => {
  const slug = encodeURIComponent(String(tenantSlug || '').trim());
  const uid = encodeURIComponent(String(resourceUid || '').trim());
  if (resourceType === 'business') {
    return `/admin/${slug}/businesses/${uid}#business-party-role-changes`;
  }
  if (resourceType === 'property') {
    return `/admin/${slug}/properties/${uid}#property-owner-changes`;
  }
  return `/admin/${slug}/registry-change-requests`;
};

export const isOwnRegistryProposal = (request, user) => (
  request?.proposed_by_user_id != null
  && user?.id != null
  && String(request.proposed_by_user_id) === String(user.id)
);

export const compactRegistryUid = value => {
  const uid = String(value || '').trim();
  if (!uid) return '—';
  return uid.length > 22 ? `${uid.slice(0, 10)}…${uid.slice(-8)}` : uid;
};
